import React from "react";
import { Input, Tooltip } from "antd";

const { TextArea } = Input;

interface WhatsappDirectFieldsProps {
  credentials: any;
  onChange: (key: string, value: string) => void;
}

const WhatsappDirectFields: React.FC<WhatsappDirectFieldsProps> = ({
  credentials,
  onChange,
}) => {
  return (
    <div className="d-grid" style={{ gap: 10 }}>
      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            Access Token <span className="text-danger">*</span>
          </label>
          <Tooltip title="Paste the long‑lived access token generated from your Meta / WhatsApp app.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <TextArea
          rows={3}
          placeholder="Access Token *"
          value={credentials.access_token || ""}
          onChange={(e) => onChange("access_token", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            Phone Number ID <span className="text-danger">*</span>
          </label>
          <Tooltip title="The phone number ID from the WhatsApp Business Cloud configuration.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="Phone Number ID *"
          value={credentials.phone_number_id || ""}
          onChange={(e) => onChange("phone_number_id", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            WABA ID <span className="text-danger">*</span>
          </label>
          <Tooltip title="WhatsApp Business Account ID associated with this phone number.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="WABA ID *"
          value={credentials.waba_id || ""}
          onChange={(e) => onChange("waba_id", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            App ID (optional)
          </label>
          <Tooltip title="Meta App ID if you want to link this configuration to a specific app.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="App ID (optional)"
          value={credentials.app_id || ""}
          onChange={(e) => onChange("app_id", e.target.value)}
        />
      </div>
    </div>
  );
};

export default WhatsappDirectFields;
